import { useMemo } from 'react';
import { IBasicDetails } from '../../../../../interface/interfaces';
import { useAppSelector } from '../../../../../redux/hooks';
import { rootState } from '../../../../../redux/store';

const useUpdatedStagingData = () => {
    // Pristup staging podacima i listi izbrisanih avatara iz Redux stanja
    const { stagingLoading, stagingData, stagingError } = useAppSelector((state: rootState) => state.stagingList);
    const { deletedAvatarsIdList } = useAppSelector((state: rootState) => state.deletedAvatarId);

    // Kreiramo memoizovan staging list, tako da se ne računa pri svakom renderovanju
    const stagingList = useMemo(() => (Array.isArray(stagingData) ? stagingData : []), [stagingData]);

    // Filtriranje liste da uklonimo obrisane stavke
    const updatedList = useMemo(() => stagingList.filter((deletedStagingItem: IBasicDetails) => !deletedAvatarsIdList?.includes(deletedStagingItem.Id)), [stagingList, deletedAvatarsIdList]);

    // Vraćamo potrebne podatke za dalju upotrebu u komponentama
    return { stagingLoading, stagingData, updatedList, stagingError };
};

export default useUpdatedStagingData;
